const partners = [
  {
    name: "Praxis Yoga",
    logo: "assets/praxis.png",
    link: "https://www.pulsewellnessco.com/",
    codeText: "Get your first class FREE with our exclusive code",
    code: "CWPT",
    buttonText: "Show Code",
  },
  {
    name: "Libin Web Development",
    logo: "assets/yellowkl.png",
    link: "https://libinwebdevelopment.com",
    codeText: "Mention code to get $50 off any website",
    code: "CWPT-20",
    buttonText: "Show Code",
  },
  {
    name: "Black Horse Ranch",
    logo: "assets/blackhorse.png",
    link: "https://www.blackhorseranchllc.com",
    codeText: "Get 10% off your first order at Black Horse",
    code: "WELLNESS",
    buttonText: "Show Code",
  },

  {
    name: "Truvani",
    logo: "assets/truvani.png",
    link: "https://www.conciergewellnessandpt.com/contact",
    codeText: "Get 20% off through Dr. Wade",
    buttonText: "Contact Dr. Wade",
  },
  {
    name: "Thorne",
    logo: "assets/thorne-logo.svg",
    link: "https://www.thorne.com/u/conciergewellness",
    codeText: "Click the link above to get 20% off your order",
    buttonText: "Shop Now",
  },
  {
      name: "Iron Wild Fitness",
    logo: "assets/ironwild.webp",
    link: "https://www.ironwildfitnesscos.com/",
    codeText: "Members get 10% off services",
    buttonText: "Schedule Now",
  },
  {
    name: "Pinnacle Weightlifting",
    logo: "assets/pinnacle.png",
    link: "https://calendly.com/conciergewellness/pinnacle-60-minute-evaluation",
    codeText: "Members get 10% off services",
    buttonText: "Schedule Now",
  },
    {
    name: "Crossfit Endemic",
    logo: "assets/endemiclogo.png",
    link: "https://www.crossfitendemic.com/",
    codeText: "Members get 10% off services",
    buttonText: "Schedule Now",
  },
    {
     name: "Beonixe",
    logo: "assets/beonixe.png",
    link: "https://beonixe.com/?ref=CHRISTIANWADE",
    codeText: "Get 10% off your order",
    code: "WELLNESS10",
    buttonText: "Show Code",
  },

];

export default partners;
